import { Municipalities } from '@dofleini/location-ui';
import { Form } from 'antd';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

const MunicipalityMultipleSelect = ({ onChange, province, ...props }) => {
  return (
    <Municipalities
      {...props}
      provAcr={province}
      onChange={onChange}
      disabled={!province}
      canSearch
    />);
};

export default memo(MunicipalityMultipleSelect);

MunicipalityMultipleSelect.defaultProps = {
  province: '',
};

MunicipalityMultipleSelect.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  province: PropTypes.any,
};

export const renderMultipleMunicipalitySelect = ({ formItemProps, field, form }, parentProvince) => {
  
  return (
    <Form.Item {...formItemProps} initialValue={field?.initialValue} required={field?.required}>
      <MunicipalityMultipleSelect {...field?.widgetProps} {...field} province={parentProvince} form={form}/>
    </Form.Item>
  );
};

renderMultipleMunicipalitySelect.propTypes = {
  formItemProps: PropTypes.object,
  field: PropTypes.object,
  form: PropTypes.object,
};
